import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {numberLike} from "#template/nodes/number/fundamental"
import type {NumberLike} from "#template/nodes/types"
import {GeometryValueNode} from "#template/nodes/geometry-graph/value/value-node"

export type ScalarArg = NumberLike | GeometryValueNode
export const scalarArg: z.ZodMiniType<ScalarArg, ScalarArg> = z.union([numberLike, graphNode(GeometryValueNode)])
